import Image from 'next/image';
import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';

import { HAS_FREE_PLAN } from '@/constants/common';
import { roomThemesList } from '@/constants/roomThemes';

export const RoomThemes = () => {
  const { t } = useLocale('ai-interior');

  return (
    <div className='relative mx-auto max-w-6xl md:px-8 xl:px-0'>
      <div className='pb-16 pt-14'>
        <div className='px-4 sm:px-6 md:px-0'>
          <div className='mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8'>
            <h2 className='mb-2 text-3xl font-black tracking-tight text-primary-600 sm:text-4xl'>
              {t('Choose from 30+ interior design styles')}
            </h2>
          </div>
          <div className='mt-8'>
            <ul className='grid grid-cols-2 gap-5 sm:grid-cols-3 xl:grid-cols-4'>
              {roomThemesList.map((theme) => (
                <li key={theme.slug} className='group'>
                  <div className='relative h-[160px] w-full overflow-hidden rounded-xl'>
                    <Image
                      src={`https://media.easy-peasy.ai/room-themes/${theme.slug}.jpeg?v=1`}
                      alt={theme.theme}
                      width={300}
                      height={300}
                      className='absolute inset-0 h-full w-full rounded-xl object-cover transition-transform duration-500 group-hover:scale-110'
                    />
                    <div className='absolute inset-0 rounded-xl ring-1 ring-inset ring-black/10 transition-all duration-300 group-hover:ring-primary-500/40' />
                  </div>
                  <div className='mt-2 px-1 text-sm font-semibold text-gray-700 dark:text-slate-300'>
                    {t(theme.theme) as string}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className='mb-16 sm:flex sm:justify-center'>
        <Link
          href={
            HAS_FREE_PLAN ? `/login?preset=ai-interior-designer` : '/#pricing'
          }
          className='inline-flex items-center justify-center rounded-full bg-primary-600 px-8 py-3.5 text-base font-semibold text-white shadow-lg shadow-primary-500/20 transition-all duration-300 hover:bg-primary-700 hover:shadow-xl hover:shadow-primary-500/30 hover:scale-[1.03] active:scale-[0.98]'
        >
          {t('Try it yourself for free')}
        </Link>
      </div>
    </div>
  );
};
